export function createRedirectToken(): string {
  const bytes = window.crypto.getRandomValues(new Uint8Array(16));

  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}

export function getMobileRedirectUrl(path?: string): URL {
  const origin = new URL(window.location.origin);

  if (!path) {
    return origin;
  }

  const pathname = path.charAt(0) === '/' ? path.slice(1) : path;

  return new URL(`${origin}${pathname}`);
}

export function createRedirectUrl(redirectToken: string): string {
  const url = getMobileRedirectUrl(import.meta.env.VITE_APP_BASE_PATH);

  url.searchParams.set('redirectToken', redirectToken);

  return url.href;
}

export function detectedVerificationAfterRedirect({ redirectToken }: { redirectToken?: string }): boolean {
  return Boolean(redirectToken);
}
